export default "__VITE_ASSET____5MpP$H__"